{
  "Any Provider (No preference)": "Any Provider (No preference)",
  "Back": "Back",
  "Booking progress": "Booking progress",
  "Call the Practice": "Call the Practice",
  "Continue": "Continue",
  "Date and Time": "Date and Time",
  "Next availability:": "Next availability:",
  "Or select a specific provider": "Or select a specific provider",
  "Provider": "Provider",
  "Select a location": "Select a location",
  "Select a provider": "Select a provider",
  "Service Type": "Service Type",
  "Something went wrong on our end and your appointment was not booked.": "Something went wrong on our end and your appointment was not booked.",
  "Start Over": "Start Over",
  "We couldn't complete your booking.": "We couldn't complete your booking.",
  "What can we help you with?": "What can we help you with?",
  "You were away for a bit, so we ended your session. Nothing was saved.": "You were away for a bit, so we ended your session. Nothing was saved.",
  "Your session has expired": "Your session has expired",
  "pages": "pages"
}
